import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipDirective } from './directives';
import { TooltipComponent } from './tooltip.component';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
  declarations: [TooltipDirective, TooltipComponent],
  imports: [CommonModule, OverlayModule],
  exports: [TooltipDirective, TooltipComponent],
})
export class TooltipModule {}
